import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { LockType } from '@/components/forms/lock_actions/LockForm/types';
import useVeBalLockInfoQuery from '@/composables/queries/useVeBalLockInfoQuery';
import { expectedVeBal } from '@/composables/useVeBAL';
import { VeBalLockInfo } from '@/services/balancer/contracts/contracts/veBAL';
import { Pool } from '@/services/pool/types';
import { TokenInfo } from '@/types/TokenList';

import useLockState from '../../composables/useLockState';
import LockActions from './components/LockActions.vue';
import LockAmount from './components/LockAmount.vue';
import LockSummary from './components/LockSummary.vue';

/**
 * TYPES
 */
type Props = {
  lockablePool: Pool;
  lockablePoolTokenInfo: TokenInfo;
  lockAmount: string;
  lockEndDate: string;
  lockType: LockType[];
  veBalLockInfo: VeBalLockInfo;
  totalLpTokens: string;
};

/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    lockablePool: { type: null, required: true },
    lockablePoolTokenInfo: { type: null, required: true },
    lockAmount: { type: String, required: true },
    lockEndDate: { type: String, required: true },
    lockType: { type: Array, required: true },
    veBalLockInfo: { type: null, required: true },
    totalLpTokens: { type: String, required: true }
  } as unknown as undefined,
  emits: ["close"] as unknown as undefined,
  setup(__props: {
  lockablePool: Pool;
  lockablePoolTokenInfo: TokenInfo;
  lockAmount: string;
  lockEndDate: string;
  lockType: LockType[];
  veBalLockInfo: VeBalLockInfo;
  totalLpTokens: string;
}, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props




/**
 * STATE
 */
const lockConfirmed = ref(false);
const lockablePool = ref(props.lockablePool);
const lockablePoolTokenInfo = ref(props.lockablePoolTokenInfo);
const lockAmount = ref(props.lockAmount);
const lockEndDate = ref(props.lockEndDate);
const lockType = ref(props.lockType);
const veBalLockInfo = ref(props.veBalLockInfo);
const totalLpTokens = ref(props.totalLpTokens);

// This value should be static when modal is opened.
const expectedVeBalAmount = expectedVeBal(
  totalLpTokens.value,
  lockEndDate.value
);

/**
 * COMPOSABLES
 */
const { t } = useI18n();
const { refetch: refetchLockInfo } = useVeBalLockInfoQuery();
const { resetState } = useLockState();

/**
 * COMPUTED
 */
const title = computed(() => {
  if (lockType.value.length === 1) {
    return lockConfirmed.value
      ? t(`getVeBAL.previewModal.titles.${lockType.value[0]}.confirmed`)
      : t(`getVeBAL.previewModal.titles.${lockType.value[0]}.default`);
  }
  return lockConfirmed.value
    ? t(`getVeBAL.previewModal.titles.${LockType.CREATE_LOCK}.confirmed`)
    : t(`getVeBAL.previewModal.titles.${LockType.CREATE_LOCK}.default`);
});

/**
 * METHODS
 */
function handleClose() {
  emit('close');
}

function handleSuccess() {
  lockConfirmed.value = true;
  refetchLockInfo.value();
  resetState();
}

return (_ctx: any,_cache: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalCircle = _resolveComponent("BalCircle")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: "",
    fireworks: lockConfirmed.value,
    onClose: handleClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (lockConfirmed.value)
          ? (_openBlock(), _createBlock(_component_BalCircle, {
              key: 0,
              size: "8",
              color: "green",
              class: "mr-2 text-white"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BalIcon, { name: "check" })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("h4", null, _toDisplayString(_unref(title)), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(LockAmount, {
        lockablePool: lockablePool.value,
        totalLpTokens: totalLpTokens.value
      }, null, 8, ["lockablePool", "totalLpTokens"]),
      _createVNode(LockSummary, {
        lockablePool: lockablePool.value,
        totalLpTokens: totalLpTokens.value,
        lockAmount: lockAmount.value,
        lockEndDate: lockEndDate.value,
        expectedVeBalAmount: _unref(expectedVeBalAmount),
        lockType: lockType.value,
        veBalLockInfo: veBalLockInfo.value
      }, null, 8, ["lockablePool", "totalLpTokens", "lockAmount", "lockEndDate", "expectedVeBalAmount", "lockType", "veBalLockInfo"]),
      _createVNode(LockActions, {
        lockablePool: lockablePool.value,
        lockAmount: lockAmount.value,
        lockEndDate: lockEndDate.value,
        lockType: lockType.value,
        lockablePoolTokenInfo: lockablePoolTokenInfo.value,
        class: "mt-4",
        onSuccess: handleSuccess
      }, null, 8, ["lockablePool", "lockAmount", "lockEndDate", "lockType", "lockablePoolTokenInfo"])
    ]),
    _: 1
  }, 8, ["fireworks"]))
}
}

})